import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { PutChannelExpirationSettings } from "../schemas/schemas_0";
export { $Command };
export class PutChannelExpirationSettingsCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "PutChannelExpirationSettings", {})
    .n("ChimeSDKMessagingClient", "PutChannelExpirationSettingsCommand")
    .sc(PutChannelExpirationSettings)
    .build() {
}
